/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
    'jquery',
    'domReady!'
    ], function($){
        "use strict";
        return function(config) {
            const inputSelector    = config.qtyInput,
                  $qtyGlobal       = $(config.qtyGlobal),
                  qtyMinusSelector = config.qtyMinus,
                  qtyPlusSelector  = config.qtyPlus,
                  qtyIncrements    = (config.qtyIncrements ? parseInt(config.qtyIncrements) : 1);


            // Qty change function
            const changeQty = ($button, $input) => {
                const currentValue = parseInt($input.val()),
                      $qtyMinusBtn = $button.parent().children(qtyMinusSelector);

                let newValue;

                // Add or subtract one from current qty
                if($button.is(qtyPlusSelector)) {
                    newValue = currentValue + qtyIncrements;
                } else {
                    newValue = currentValue - qtyIncrements;
                }

                // Set the new value
                $input.val(newValue).change();

                // Disable minus button if the new qty is the same as the minimal qty
                if(newValue <= $input.data('default-value')) {
                    $qtyMinusBtn.prop('disabled', true);
                } else {
                    $qtyMinusBtn.prop('disabled', false);
                }
            };

            $qtyGlobal.click(function () {
                const $button = $(this);
                const $input  = $button.siblings(inputSelector);

                changeQty($button, $input);
            });
        }
    }
);
